// extracted by mini-css-extract-plugin
export default {"HoverBrochure":"Brochure_HoverBrochure__Udn9m","BrochureDark":"Brochure_BrochureDark__sSrpf"};